import { createMockCreator } from '@csp/test-common-utils';
import { BioSamplingSupplyContainerV1 } from '../generated/models/BioSamplingSupplyContainerV1';

const template: BioSamplingSupplyContainerV1 = {
  containerId: 'c1',
  audit: {
    createdAt: '2020-04-16T16:04:31.972+02:00[Europe/Stockholm]',
    createdBy: 'author1',
    lastModified: '2021-04-16T16:04:31.972+02:00[Europe/Stockholm]',
    modifiedBy: 'author2',
  },
  eventId: 'e1',
  dCode: 'study1',
  containerCode: '012345678901',
  containerNumber: '1',
  kitCode: '0123456789',
  containerType: 'c1',
  kitType: 'k1',
  containerDescription: 'Container desc',
  kitDescription: 'Kit desc',
  kitExpirationDate: '2090-01-01',
  practiceCode: '4523',
  labelInformation: 'Hematology panel',
  sampleType: 'Whole Blood, EDTA, Dry',
  returnType: 'NT: Not Return',
  groupDescription: 'BNHEMATOLOGY&DIFFERENTIAL PANEL|HEMOGLOBIN A1CP',
  sampleRequired: false,
};

export const createBioSamplingContainerV1Mock = createMockCreator<BioSamplingSupplyContainerV1>(template);
